import React, { useCallback, useEffect, useState } from "react";
import classes from "./DistributionList.module.scss";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  distributeTo,
  distributionListFormSchema,
} from "../../../../utils/mainTabs/distribute/distributeTo";
import Input from "../../../../components/Common/Input/Input";
import Button from "../../../../components/Common/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  getCityListActionHandler,
  getCountryListActionHandler,
  getProductCategoryListActionHandler,
  getStateListActionHandler,
  getWorkOfficeListActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/userManagementActionHandler";
import {
  distributeClassesActionHandler,
  getStoreListByCountryIdActionHandler,
  getStoreListByStoreIdActionHandler,
  getWorkOrOfficeLocationListActionHandler,
} from "../../../../store/actions/actionHandlers/distributeActionHandler";
import TreeList from "../../../../components/Common/ReactForm/TreeList/TreeList";
import { useNavigate, useOutletContext } from "react-router";
import { distribute } from "../../../../utils/mainTabs/distribute/distribute";
import { FormattedMessage } from "react-intl";

const DistributionList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { selectedUserGroup, tenantName, setLoading } = useOutletContext();
  const { formFields } = distributeTo.distributionListForm;
  const [fields, setFields] = useState(formFields());
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [userDepartmentList, setUserDepartmentList] = useState([]);
  const [selectedCatagoryId, setSelectedCatagoryId] = useState(null);
  const [distributeLoader, setDistributeLoader] = useState(false);
  const methods = useForm({
    resolver: yupResolver(distributionListFormSchema),
    defaultValues: {},
  });
  const {
    formState: { errors, isDirty },
    setValue,
    reset,
    handleSubmit,
    getValues,
  } = methods;
  const adminStateReducer = useSelector((state) => state.adminReducer);
  const { userManagementReducer } = adminStateReducer;
  const {
    getCountryListLoader,
    getStateListLoader,
    getCityListLoader,
    getWorkOfficeListLoader,
  } = userManagementReducer;
  const distributeState = useSelector((state) => state.distributeReducer);
  const [catagoryName, setcatagoryName] = useState("");
  const { selctedShotclassData, selctedSeriesData } = distributeState;
  const formValues = getValues();
  const handleSelectCountry = useCallback(
    (e) => {
      let countryId = e.target.value;
      setValue("State", null);
      setValue("City", null);
      setValue("Store", null);
      setCityList([]);
      setStoreList([]);
      dispatch(getStateListActionHandler(countryId)).then((stateList) => {
        setStateList(stateList);
      });
      dispatch(getStoreListByCountryIdActionHandler(countryId)).then(
        (storeList) => {
          setStoreList(storeList);
        }
      );
    },
    [dispatch, setValue]
  );

  const handleSelectState = useCallback(
    (e) => {
      let stateId = e.target.value;
      setValue("City", null);
      setStoreList([]);
      dispatch(getCityListActionHandler(stateId)).then((cityList) => {
        setCityList(cityList);
      });
    },
    [dispatch, setValue]
  );

  const handleSelectCity = useCallback(
    (e) => {
      let cityId = e.target.value;
      dispatch(getWorkOfficeListActionHandler(cityId)).then((storeList) => {
        setStoreList(storeList);
      });
    },
    [dispatch]
  );

  const handleSelectStore = useCallback(
    (e) => {
      let storeId = e.target.value;
      dispatch(getStoreListByStoreIdActionHandler(storeId)).then((store) => {
        setValue("Country", store[0]?.CountryId);
        const stateDetails = [
          {
            Id: store?.[0]?.StateId,
            StateName: store?.[0]?.StateName,
          },
        ];
        setStateList(stateDetails);
        setValue("State", stateDetails?.[0]?.Id);
        const cityeDetails = [
          {
            Id: store?.[0]?.CityId,
            CityName: store?.[0]?.CityName,
          },
        ];
        setCityList(cityeDetails);
        setValue("City", cityeDetails?.[0]?.Id);
      });
    },
    [dispatch, setValue]
  );

  useEffect(() => {
    dispatch(getProductCategoryListActionHandler()).then((data) => {
      setUserDepartmentList(data);
    });
    dispatch(getWorkOrOfficeLocationListActionHandler()).then((stateList) => {
      setStoreList(stateList);
    });
    dispatch(getCountryListActionHandler()).then((countryList) => {
      setCountryList(countryList);
    });
  }, [dispatch]);

  useEffect(() => {
    let formArgs = {
      countryList,
      handleSelectCountry,
      getCountryListLoader,
      stateList,
      handleSelectState,
      getStateListLoader,
      cityList,
      handleSelectCity,
      getCityListLoader,
      storeList,
      setStoreList,
      getWorkOfficeListLoader,
      userDepartmentList,
      handleSelectStore,
    };
    const fieldsList = formFields(formArgs);
    setFields(fieldsList);
  }, [
    formFields,
    countryList,
    handleSelectCountry,
    getCountryListLoader,
    stateList,
    handleSelectState,
    getStateListLoader,
    cityList,
    handleSelectCity,
    getCityListLoader,
    storeList,
    getWorkOfficeListLoader,
    userDepartmentList,
    handleSelectStore,
  ]);

  const onSubmit = (data) => {
    const cityName = cityList?.find(
      (item) => parseInt(item?.Id) === parseInt(data?.City)
    );
    const countryName = countryList?.find(
      (item) => parseInt(item?.Id) === parseInt(data?.Country)
    );
    const stateName = stateList?.find(
      (item) => parseInt(item?.Id) === parseInt(data?.State)
    );
    const obj = {
      CategoryHierarchy: `${
        countryName?.CountryName ? countryName?.CountryName + ";" : ""
      }${cityName?.CityName ? cityName?.CityName + ";" : ""}${
        stateName?.StateName ? stateName?.StateName + ";" : ""
      }${catagoryName}`,
      ClassGroups: selctedShotclassData?.concat(selctedSeriesData),
      DistributedTo: 2,
      SelectedUsers: [],
      TagExpression: {
        Category: catagoryName,
        CityId: parseInt(data?.City),
        CountryId: parseInt(data?.Country),
        StateId: parseInt(data?.State),
        StoreId: formValues?.Store,
      },
      UserGroups: selectedUserGroup,
    };
    dispatch(
      distributeClassesActionHandler(
        obj,
        setDistributeLoader,
        navigate,
        tenantName,
        setLoading
      )
    );
  };

  return (
    <BoxLayout>
      <FormProvider {...methods}>
        <form
          className={classes.distribution_list_form}
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className={classes.distribution_list_form_fields}>
            {fields?.map((field) => {
              return (
                <div
                  className={classes.selectUserLocation__form__fields__field}
                  key={field?.key}
                >
                  <Input
                    label={field?.label}
                    name={field?.name}
                    placeholder={field?.placeholder}
                    labelColor={field?.labelColor}
                    error={errors?.[field?.name]?.message}
                    type={field?.type}
                    fieldName={field?.fieldName}
                    fieldValue={field?.fieldValue}
                    valueArr={field?.valueArr}
                    onChange={field?.onChange}
                    height={field?.height}
                    width={field?.width}
                    searchTagsList={field?.searchTagsList}
                    handleTagList={field?.handleTagList}
                    disabled={field?.disabled}
                    loading={field?.loading}
                    isNested={field?.isNested}
                    nestFieldName={field?.nestFieldName}
                    isTagCheckBoxVisible={field?.isTagCheckBoxVisible}
                  />
                </div>
              );
            })}
            <TreeList
              placeholder="Select Department"
              label={<FormattedMessage id="DIST_HISTORY_CATEGORY" />}
              productCategory={userDepartmentList}
              setCategoryId={setSelectedCatagoryId}
              width="32"
              setcatagoryName={setcatagoryName}
              catagoryName={catagoryName}
            />
          </div>
          <div className={classes.footer}>
            {isDirty || selectedCatagoryId ? (
              <div
                className={classes.clear_all}
                onClick={() => {
                  reset();
                  setSelectedCatagoryId("");
                  setcatagoryName("");
                }}
              >
                <FormattedMessage id="RESET_MSG" />
              </div>
            ) : (
              <div
                className={classes.clear_all}
                onClick={() => navigate(distribute.classPath(tenantName))}
              >
                <FormattedMessage id="CANCEL_TEXT" />
              </div>
            )}
            <Button
              label={<FormattedMessage id="Distribute" />}
              small
              dark
              type="submit"
              backgroundColor={distributeLoader ? undefined : "#D31B61"}
              loading={distributeLoader}
              disabled={
                formValues?.Country ||
                formValues?.City ||
                formValues?.State ||
                formValues?.Store ||
                selectedCatagoryId
                  ? false
                  : true
              }
            />
          </div>
        </form>
      </FormProvider>
    </BoxLayout>
  );
};

export default DistributionList;
